export const TIMEOUT_VNPAY = 15 * 60 * 1000
export const TRANSACTION_VIETINBANK_TIMEOUT = 15 * 60 * 1000
export const TRANSACTION_SHB_TIMEOUT = 30 * 60 * 1000
export const TRANSACTION_BIDV_TIMEOUT = 30 * 60 * 1000
export const TRANSACTION_ONEPAY_TIMEOUT = 5 * 60 * 1000
export const TRANSACTION_ACB_TIMEOUT = 15 * 60 * 1000
export const TRANSACTION_VCB_TIMEOUT = 2 * 60 * 60 * 1000
export const TRANSACTION_KLB_TIMEOUT = 6 * 60 * 60 * 1000
export const TRANSACTION_AGRI_TIMEOUT = 60 * 60 * 1000
export const TRANSACTION_PVCB_TIMEOUT = 15 * 60 * 1000

export const QR_PAYMENT_TIMEOUT_MS = {
  VNPAY: TIMEOUT_VNPAY,
  VNPAYQR: TIMEOUT_VNPAY,
  VIETINBANK: TRANSACTION_VIETINBANK_TIMEOUT,
  SHB: TRANSACTION_SHB_TIMEOUT,
  BIDV: TRANSACTION_BIDV_TIMEOUT,
  ONEPAY: TRANSACTION_ONEPAY_TIMEOUT,
  ACB: TRANSACTION_ACB_TIMEOUT,
  VCB: TRANSACTION_VCB_TIMEOUT,
  KLB: TRANSACTION_KLB_TIMEOUT,
  AGRIBANK: TRANSACTION_AGRI_TIMEOUT,
  PVCB: TRANSACTION_PVCB_TIMEOUT,
} as const

export type QrPaymentChannel = keyof typeof QR_PAYMENT_TIMEOUT_MS

// Future API adapters should convert the server expiry to an absolute Unix timestamp in milliseconds.
export const resolveQrExpiresAtMs = (channel: QrPaymentChannel, startedAtMs: number, expiresAtMs?: number): number =>
  typeof expiresAtMs === 'number' && Number.isFinite(expiresAtMs) && expiresAtMs >= 0
    ? expiresAtMs
    : startedAtMs + QR_PAYMENT_TIMEOUT_MS[channel]

export const getQrRemainingSeconds = (expiresAtMs: number, nowMs: number): number =>
  Math.max(Math.ceil((expiresAtMs - nowMs) / 1000), 0)
